import { TextField, Typography } from "@mui/material"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { ALL_LOCALES_TYPE, ITranslation } from "../model"
import { translate } from "../service"

interface ITranslationFieldProps {
  translation: ITranslation
  setTranslation: (translation: ITranslation) => any
  sx?: any
}

export const TranslationField = ({ translation, setTranslation, sx }: ITranslationFieldProps) => (
  <FlexBox vertical gap sx={sx}>
    {Object.keys(translation).map((locale, index) => (
      <FlexBox gap key={index}>
        <Typography color="textPrimary" fontSize=".85rem" sx={{ minWidth: "4rem" }}>
          {translate(`label.language.${locale}`)}
        </Typography>
        <TextField
          value={translation[locale as ALL_LOCALES_TYPE]}
          size="small"
          onChange={event => setTranslation({ ...translation, [locale]: event.target.value })}
        />
      </FlexBox>
    ))}
  </FlexBox>
)
